import React from 'react'

const Dashboard7 = () => {
  return (
    <h1>Dashboard7</h1>
  )
}

export default Dashboard7